import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { PlanConflict, PlanCreate, PlanEntity, PlanResolveConflict, PlanUpdate } from '../models';
import { getFieldToUpdateModel } from '../adapters';
import { DataGetRequest } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root'
})
export class PlanApiService extends BaseApi<PlanEntity> {
  constructor() {
    super('', {
      get: '/Plan/admin/GetPlanList'
    });
  }

  getPlan(id: number) {
    return http$.get<PlanEntity>(`/Plan/admin/GetPlan?Id=${id}`);
  }

  createPlan(model: PlanCreate) {
    return http$.post('/Plan/admin/CreatePlan', model);
  }

  updatePlan(id: number, model: PlanUpdate) {
    return http$.put('/Plan/admin/UpdatePlan', { id, plan: getFieldToUpdateModel(model) });
  }

  deletePlan(id: number) {
    return http$.delete('/Plan/admin/DeletePlan', { body: { id } });
  }

  getPlanItems() {
    return this.getItemRecords(plan => plan.name, false);
  }

  getPlanConflicts(id: number) {
    return http$.get<PlanConflict[]>(`/Plan/admin/GetPlanConflicts?PlanId=${id}`);
  }

  resolvePlanConflict(model: PlanResolveConflict) {
    return http$.post(`/Plan/admin/ResolveConflict`, model);
  }

  exportPlanAssetAudits(id: number, query?: DataGetRequest) {
    return super.exportAndDownload(`/Property/admin/ExportPlanAssetAudits?PlanId=${id}`, query, 'plan-asset-audits');
  }
}
